module.exports = __webpack_public_path__ + "static/media/financecase5.54de28b3.png";